export default __webpack_public_path__ + "static/media/large.e4341da9.jpeg";